import {
  UPDATE_PROFILE_ACTIVITATE,
  UPDATE_PROFILE_ACTIVITATE_SUCCESS,
  UPDATE_PROFILE_ACTIVITATE_ERROR,
  UPDATE_PROFILE_DEACTIVATE_SUCCESS,
  UPDATE_PROFILE_DEACTIVATE_ERROR,
  UPDATE_PROFILE_DEACTIVATE,
} from "./actionTypes";

export const updateProfileActivate = (data, callback) => {
  return {
    type: UPDATE_PROFILE_ACTIVITATE,
    payload: data,
    callback
  };
};

export const updateProfileActivateSuccess = (message) => {
  return {
    type: UPDATE_PROFILE_ACTIVITATE_SUCCESS,
    payload: message,
  };
};

export const updateProfileActivateError = (message) => {
  return {
    type: UPDATE_PROFILE_ACTIVITATE_ERROR,
    payload: message,
  };
};

// deactivate account in individaual profile
export const updateProfileDectivate = (data, callback) => {
  return {
    type: UPDATE_PROFILE_DEACTIVATE,
    payload: data,
    callback
  };
};

export const updateProfileDectivateSuccess = (message) => {
  return {
    type: UPDATE_PROFILE_DEACTIVATE_SUCCESS,
    payload: message,
  };
};

export const updateProfileDectivateError = (message) => {
  return {
    type: UPDATE_PROFILE_DEACTIVATE_ERROR,
    payload: message,
  };
};